
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("1aznn"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("1aznn", function(module, exports) {

let $0da22a936fb74517$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0da22a936fb74517$var$load("h3ABO"),
    $0da22a936fb74517$var$load("l0dTs"),
    $0da22a936fb74517$var$load("9hYRW"),
    $0da22a936fb74517$var$load("kpm7S"),
    $0da22a936fb74517$var$load("gwky3"),
    $0da22a936fb74517$var$load("cWN1a"),
    $0da22a936fb74517$var$load("2YffH"),
    $0da22a936fb74517$var$load("g7ggm"),
    $0da22a936fb74517$var$load("6mHrv"),
    $0da22a936fb74517$var$load("awWN9"),
    $0da22a936fb74517$var$load("cM9WO"),
    $0da22a936fb74517$var$load("3wNgF"),
    $0da22a936fb74517$var$load("8tyVc"),
    $0da22a936fb74517$var$load("hZtKG"),
    $0da22a936fb74517$var$load("dkqvW"),
    $0da22a936fb74517$var$load("lVO3w"),
    $0da22a936fb74517$var$load("hyzoX"),
    $0da22a936fb74517$var$load("cmqxT"),
    $0da22a936fb74517$var$load("h9Ed7"),
    $0da22a936fb74517$var$load("eBRUf"),
    $0da22a936fb74517$var$load("ggdmt"),
    $0da22a936fb74517$var$load("kbRvk"),
    $0da22a936fb74517$var$load("7gHIc"),
    $0da22a936fb74517$var$load("3sb7M"),
    $0da22a936fb74517$var$load("k3jER"),
    $0da22a936fb74517$var$load("9wzNh"),
    $0da22a936fb74517$var$load("8YSo7"),
    $0da22a936fb74517$var$load("ef2hX"),
    $0da22a936fb74517$var$load("aGzPe"),
    $0da22a936fb74517$var$load("9ldRJ"),
    $0da22a936fb74517$var$load("50ame"),
    $0da22a936fb74517$var$load("7do1E"),
    $0da22a936fb74517$var$load("77dkW"),
    $0da22a936fb74517$var$load("1MlIV"),
    $0da22a936fb74517$var$load("9ijrN"),
    $0da22a936fb74517$var$load("6iz6l"),
    $0da22a936fb74517$var$load("4SCW2"),
    $0da22a936fb74517$var$load("jYV57"),
    $0da22a936fb74517$var$load("76qVV"),
    $0da22a936fb74517$var$load("hv4mn"),
    $0da22a936fb74517$var$load("Wowvf"),
    $0da22a936fb74517$var$load("dYtBN"),
    $0da22a936fb74517$var$load("6wr18"),
    $0da22a936fb74517$var$load("kjZZD"),
    $0da22a936fb74517$var$load("55Z9F"),
    $0da22a936fb74517$var$load("4vp3Q"),
    $0da22a936fb74517$var$load("4m4Yp"),
    $0da22a936fb74517$var$load("37ldp"),
    $0da22a936fb74517$var$load("ffEVr"),
    $0da22a936fb74517$var$load("9AXkC"),
    $0da22a936fb74517$var$load("28arV"),
    $0da22a936fb74517$var$load("hhss7"),
    $0da22a936fb74517$var$load("fiBiE"),
    $0da22a936fb74517$var$load("lBssV"),
    $0da22a936fb74517$var$load("dP7ao"),
    $0da22a936fb74517$var$load("hogcU"),
    $0da22a936fb74517$var$load("dVY98"),
    $0da22a936fb74517$var$load("jKuFd"),
    $0da22a936fb74517$var$load("7EorR"),
    $0da22a936fb74517$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.44e0cce4.js.map
